import { styled } from '@mui/material/styles';
import Switch from '@mui/material/Switch';

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '& .MuiSwitch-switchBase': {
    padding: 2,
    color: theme.palette.common.white,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: theme.palette.common.white,
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
      },
    },
    '& + .MuiSwitch-track': {
      opacity: 1,
      backgroundColor: theme.palette.action.disabledBackground,
      borderColor: theme.palette.action.disabledBackground,
    },
  },
  '& .MuiSwitch-thumb': {
    width: 12,
    height: 12,
    boxShadow: 'none',
  },
  '& .MuiSwitch-track': {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white,
  },
}));

export default AntSwitch;
